import { lazy } from 'react';
import { retry } from '@/utils/helpers/common';

// JWT Authentication pages
export const JwtLoginPage = lazy(
  () =>
    retry(() => import('@/pages/auth/jwt/login')) as Promise<
      typeof import('@/pages/auth/jwt/login')
    >
);

export const JwtRegisterPage = lazy(
  () =>
    retry(() => import('@/pages/auth/jwt/register')) as Promise<
      typeof import('@/pages/auth/jwt/register')
    >
);

export const ResetPasswordPage = lazy(
  () =>
    retry(() => import('@/pages/auth/jwt/reset-password')) as Promise<
      typeof import('@/pages/auth/jwt/reset-password')
    >
);
